/**
 * Centralised data-testid identifiers.
 * Every interactive element + critical info element MUST appear here.
 */

export const TID = {
  // Splash & Home
  splash: 'splash-screen',
  home: 'home-screen',
  logo: 'kickard-logo',
  playVsBotBtn: 'play-vs-bot-btn',
  tutorialBtn: 'tutorial-btn',
  settingsBtn: 'settings-btn',
  statsBtn: 'stats-btn',

  // Tutorial
  tutorialScreen: 'tutorial-screen',
  tutorialNext: 'tutorial-next-btn',
  tutorialSkip: 'tutorial-skip-btn',
  tutorialStart: 'tutorial-start-match-btn',

  // Settings
  settingsScreen: 'settings-screen',
  settingsSoundToggle: 'settings-sound-toggle',
  settingsClose: 'settings-close-btn',
  settingsResetStats: 'settings-reset-stats-btn',

  // Stats
  statsScreen: 'stats-screen',
  statsClose: 'stats-close-btn',

  // Game
  gameScreen: 'game-screen',
  kickoffOverlay: 'kickoff-overlay',
  scoreP1: 'score-p1',
  scoreP2: 'score-p2',
  deckCount: 'deck-count',
  discardCount: 'discard-count',
  turnIndicator: 'turn-indicator',
  timer: 'turn-timer',
  drawnCard: 'drawn-card',
  drawBtn: 'draw-card-btn',
  endTurnBtn: 'end-turn-btn',
  cancelAttackBtn: 'cancel-attack-btn',
  toastFx: 'toast-fx',

  // Slots
  slot: (player: string, type: string, idx: number) => `slot-${player}-${type}-${idx}`,
  slotCard: (player: string, type: string, idx: number) => `slot-${player}-${type}-${idx}-card`,
  opponentGoalkeeper: 'slot-p2-goalkeeper-0',
  playerGoalkeeper: 'slot-p1-goalkeeper-0',

  // Penalty
  penaltyScreen: 'penalty-screen',
  penaltyAttackCard: (i: number) => `penalty-attack-${i}`,
  penaltyAttackUsed: (i: number) => `penalty-attack-used-${i}`,
  penaltyDefenseCard: (i: number) => `penalty-defense-${i}`,
  penaltyConfirm: 'penalty-confirm-btn',
  penaltyShooter: 'penalty-shooter',

  // Match summary
  summaryScreen: 'match-summary-screen',
  summaryRematch: 'summary-rematch-btn',
  summaryHome: 'summary-home-btn',

  // Dev
  devPanel: 'dev-panel',
  devForceJoker: 'dev-force-joker-btn',
  devForcePenalty: 'dev-force-penalty-btn',
  devRestart: 'dev-restart-btn',
  devRevealAll: 'dev-reveal-all-btn',
  devClose: 'dev-close-btn',
  debugInspector: 'debug-inspector',
};
